import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, EXPIREOLD } from 'src/api';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';

export function useExpireUsersMutation() {
  const queryClient = useQueryClient();

  const { mutate: expireUsers } = useMutation({
    mutationFn: (ids: string[]) => axios.put(`${API_URL}${EXPIREOLD}`, { ids }),
    onSuccess: () => {
      queryClient.invalidateQueries('SearchUsersPaginated');
      handleSuccessToast({ toastMessage: 'User Deactivated Successfully' });
    },
    onError: () => {
      handleErrorToast({
        toastMessage: 'Something went wrong, could not deactivate user',
      });
    },
  });

  return expireUsers;
}
